<template>
<div class="chapter">
<div class="inner_page">
<p class="copy">ISBN 978 1 52674 971 0</p>
<p class="copy_">eISBN 978 1 52674 972 7</p>
<p class="copy_">Mobi ISBN 978 1 52674 973 4</p>
<p class="copy">Published in 2019 by Pen &amp; Sword Transport</p>
<p class="copy_">an imprint of Pen &amp; Sword Books Ltd, 47 Church Street,</p>
<p class="copy_">Barnsley, South Yorkshire, S70 2AS</p>
<p class="copy">Copyright © Matthew Wharmby, 2019</p>
<p class="copy">The right of Matthew Wharmby to be identified as the Author</p>
<p class="copy_">of this Work has been asserted by them in accordance with the</p>
<p class="copy_">Copyright, Designs and Patents Act 1988. A CIP catalogue record</p>
<p class="copy_">for this book is available from the British Library</p>
<p class="copy">All rights reserved. No part of this book may be reproduced</p>
<p class="copy_">or transmitted in any form or by any means, electronic or</p>
<p class="copy_">mechanical including photocopying, recording or by any</p>
<p class="copy_">information storage and retrieval system, without permission</p>
<p class="copy_">from the Publisher in writing.</p>
<p class="copy">Pen &amp; Sword Books Ltd incorporates the imprints of Pen &amp;</p>
<p class="copy_">Sword Archaeology, Atlas, Aviation, Battleground, Discovery,</p>
<p class="copy_">Family History, History, Maritime, Military, Naval, Politics,</p>
<p class="copy_">Railways, Select, Transport, True Crime, and Fiction, Frontline</p>
<p class="copy_">Books, Leo Cooper, Praetorian Press, Seaforth Publishing and</p>
<p class="copy_">Wharncliffe.</p>
<p class="copy">For a complete list of Pen &amp; Sword titles please contact</p>
<p class="copy_">PEN &amp; SWORD BOOKS LIMITED</p>
<p class="copy_">47 Church Street, Barnsley, South Yorkshire, S70 2AS,</p>
<p class="copy_">England</p>
<p class="copy">E-mail: <span class="weblink"><span class="underline"><a href="mailto:enquiries@pen-and-sword.co.uk">enquiries@pen-and-sword.co.uk</a></span></span></p>
<p class="copy_">website: <span class="weblink"><span class="underline"><a href="http://www.pen-and-sword.co.uk " target="_blank">www.pen-and-sword.co.uk</a></span></span></p>
<p class="pbk"></p>
<p class="copyy"><strong class="b">Front cover:</strong> Stagecoach East</p>
<p class="copySS">London <strong class="b">T 163</strong> (CUL 163V)</p>
<p class="copySS">at Romford, 21 April 1999.</p>
<p class="copyy"><strong class="b">Back cover, top:</strong> Blue Triangle</p>
<p class="copySS"><strong class="b">T 349</strong> (KYV 349X) at Croydon,</p>
<p class="copySS">29 August 1999.</p>
<p class="copyy"><strong class="b">Back cover, middle:</strong> London</p>
<p class="copySS">Central <strong class="b">T 1111</strong> (B111 WUV) at</p>
<p class="copySS">Crystal Palace, 11 August 1999.</p>
<p class="copyy"><strong class="b">Back cover, bottom:</strong> Stagecoach</p>
<p class="copySS">Selkent <strong class="b">T 885</strong> (A885 SUL) at</p>
<p class="copySS">Bromley South, 22 April 1999.</p>
<p class="copyy"><strong class="b">Title page:</strong> London Central <strong class="b">T 787</strong></p>
<p class="copySS">(OHV 787Y) at Bexleyheath,</p>
<p class="copySS">20 March 1999.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?50f559ef